import React from 'react';
import { ChromePicker } from 'react-color';
import styles from './NodeOptions.module.scss';

const NodeOptions = ({
  popoverVisible,
  handleOpenChromeColor,
  handleColorChange,
  colorPickerVisible,
  selectedColor,
  handleEditName,
  handleDuplicateNode,
  initial,
}) => {
  const options = [
    {
      label: 'Block Color',
      onClick: (e) => handleOpenChromeColor(e),
    },
    ...(!initial
      ? [
          { label: 'Rename', onClick: handleEditName },
          { label: 'Duplicate', onClick: handleDuplicateNode },
        ]
      : []),
  ];

  if (colorPickerVisible) {
    return (
      <div className={styles.colorPicker} onClick={(e) => e.stopPropagation()}>
        <ChromePicker
          color={selectedColor}
          onChange={handleColorChange}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    );
  }

  if (popoverVisible) {
    return (
      <div className={styles.dropdown}>
        {options.map((item, index) => (
          <div
            key={index}
            className={styles.inner}
            onClick={item.onClick || (() => {})}
          >
            <p>{item.label}</p>
          </div>
        ))}
      </div>
    );
  }

  return null;
};

export default NodeOptions;
